import React from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

export default function ProductSizeLabel({
  product,
  isOneSize,
  isMysteryBox = false,
  shouldDisplayMultipleOneSizes = false,
}) {
  if (isOneSize && !isMysteryBox && product && shouldDisplayMultipleOneSizes) {
    return product.is_plus_size ? (
      <FormattedMessage
        id="global_checkout.one_size_curvy"
        defaultMessage="1X-3X"
        whiteSpace="pre-line"
      />
    ) : (
      <FormattedMessage
        id="global_checkout.one_size_missy"
        defaultMessage="XS-XL"
        whiteSpace="pre-line"
      />
    );
  }

  if (isOneSize && !isMysteryBox) {
    return (
      <FormattedMessage
        id="global_checkout.one_size"
        defaultMessage="One Size"
        whiteSpace="pre-line"
      />
    );
  }

  // if mystery box we want the product item size instead of the general "one size" label for a set
  const bundleLabel = isMysteryBox
    ? product.bundleItems[0].instanceLabel
    : product.label_instance || product.instanceLabel || null;

  return bundleLabel;
}

ProductSizeLabel.propTypes = {
  isMysteryBox: PropTypes.bool,
  isOneSize: PropTypes.bool.isRequired,
  product: PropTypes.object.isRequired,
  shouldDisplayMultipleOneSizes: PropTypes.bool,
};
